import { LocalService } from './../storage/local.service';
import { Usuarios } from './../../interfaces/usuario';
import { ConfigService } from './../config/config.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { API_ENDPOINT } from '../config/config';

@Injectable({
  providedIn: 'root'
})
export class ServicesService {
  headers = new HttpHeaders({
    'accept': 'application/json',
    'Content-Type': 'application/json'
  });

  constructor(
    private httpClient: HttpClient,
    private config: ConfigService,
    private localSecureService: LocalService
  ) { }

  async logOff(data:any) {
    //const config = await this.config.getConfig();
    const customer = this.localSecureService.getValue('customer');
    const url = `${API_ENDPOINT.endpoint}/${customer['slug']}/logoff`;

    try {
      return await this.httpClient.post(url, data, { headers: this.headers }).toPromise();
    } catch (error: any) {
      return { status: false, code: error.error.status, message: error.error.title };
    }
  }

}


